import { useTheme } from "@emotion/react";

import Stack from '@mui/system/Stack';
import { Skeleton } from '@mui/material';


export default function ListSkeleton({ height = 20 }: { height?: number }) {

  const theme = useTheme();

  return (
    <Stack alignItems="center" justifyContent="start" sx={{ py: 1 }} spacing={2} >
      <Skeleton variant="rectangular" height={height} width="100%" sx={{ borderRadius: 1 }} />
      <Skeleton variant="rectangular" height={height} width="100%" sx={{ borderRadius: 1 }} />
      <Skeleton variant="rectangular" height={height} width="100%" sx={{ borderRadius: 1 }} />
      <Skeleton variant="rectangular" height={height} width="100%" sx={{ borderRadius: 1 }} />
      <Skeleton variant="rectangular" height={height} width="100%" sx={{ borderRadius: 1 }} />
      <Skeleton variant="rectangular" height={height} width="100%" sx={{ borderRadius: 1 }} />
    </Stack>
  );
}
